import React, { useEffect, useState } from "react";
import { Card, Typography, Spin, Button, Row, Col } from "antd";
import TrackList from "./TrackList";
import { Link } from "react-router-dom";

const { Title } = Typography;

function ByGenres() {
  const [genres, setGenres] = useState([]);
  const [selectedGenreId, setSelectedGenreId] = useState(null);
  const [albums, setAlbums] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [loadingGenres, setLoadingGenres] = useState(true);
  const [loadingAlbums, setLoadingAlbums] = useState(false);
  const [loadingTracks, setLoadingTracks] = useState(false);

  useEffect(() => {
    fetch("https://simolmedia.tw1.ru/api/get_genres.php")
      .then((res) => res.json())
      .then((data) => {
        setGenres(data || []);
        setLoadingGenres(false);
        if (data.length > 0) {
          setSelectedGenreId(data[0].id);
          loadAlbums(data[0].id);
        }
      });
  }, []);

  const loadAlbums = (genreId) => {
    setSelectedGenreId(genreId);
    setAlbums([]);
    setTracks([]);
    setLoadingAlbums(true);
    fetch(`https://simolmedia.tw1.ru/api/get_albums_g.php?genre_id=${genreId}`)
      .then((res) => res.json())
      .then((data) => {
        setAlbums(data || []);
        setLoadingAlbums(false);
      });
  };

  const loadTracks = (albumId) => {
    setTracks([]);
    setLoadingTracks(true);
    fetch("https://simolmedia.tw1.ru/api/get_tracks_by_album.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ album_id: albumId }),
    })
      .then((res) => res.json())
      .then((data) => {
        setTracks(data || []);
        setLoadingTracks(false);
      });
  };

  return (
    <div>
      <Title level={3}>Выберите жанр</Title>

      <div style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: 20 }}>
        {loadingGenres ? (
          <Spin />
        ) : (
          genres.map((genre) => {
            const isActive = genre.id === selectedGenreId;
            return (
              <Button
                key={genre.id}
                type={isActive ? "primary" : "default"}
                onClick={() => loadAlbums(genre.id)}
                style={{ marginRight: 8, marginBottom: 8 }}
              >
                {genre.name}
              </Button>
            );
          })
        )}
      </div>

      <Title level={4}>Альбомы</Title>
      {loadingAlbums ? (
        <Spin />
      ) : albums.length === 0 ? (
        <p>Нет альбомов для этого жанра</p>
      ) : (
        <Row gutter={[16, 16]}>
          {albums.map((album) => {
            const thumbnail = album.thumbnail
              ? `https://audiobuzz-web.tmweb.ru/uploads/thumbnails/albums/${album.thumbnail}`
              : "https://audiobuzz-web.tmweb.ru/uploads/thumbnails/default_cover.jpg";

            return (
              <Col xs={12} sm={8} md={6} lg={4} key={album.id}>
                <Link
  to={`/downloads/album/${album.id}`}
  state={{
    albumName: album.name,
    albumCover: thumbnail,
  }}
>
  <Card
    hoverable
    cover={<img src={thumbnail} alt={album.name} />}
  >
    <Card.Meta title={album.name} description={album.artist_name} />
  </Card>
</Link>

                 
              </Col>
            );
          })}
        </Row>
      )}

      {tracks.length > 0 && (
        <>
          <Title level={4} style={{ marginTop: 30 }}>
            Треки
          </Title>
          {loadingTracks ? <Spin /> : <TrackList tracks={tracks} />}
        </>
      )}
    </div>
  );
}

export default ByGenres;
